<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "ForecastReportCustomerIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
